import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {
  Header,
  Transition,
  Button
} from 'semantic-ui-react'
import styles from './GenericModal.module.scss'
import { AppContext } from './../../providers'

const baseStyles = {
  content: {
  }
}

const GenericModal = (props) => {
  const { theme } = React.useContext(AppContext)


  const {
    isOpen,
    hasTitleBar,
    onClose,
    title,
    content,
    isRounded,
    modalStyles,
    children,
    icon,
  } = props

  const onHandleClose = () => {
    onClose()
  }

  const Widget = () => content

  return (
    <Modal
      isOpen={isOpen}
      appElement={document.querySelector('body')}
      className={`${
        styles.modalWindow
        } ${
        isRounded ? styles.rounded : styles.square
        }`}
      style={{
        ...modalStyles,
        ...baseStyles,
        content: {
          ...baseStyles.content,
          ...modalStyles.content
        }
      }}
    >
      <Transition visible={true} animation='scale' duration={500}>
        <div className={styles.wrapper} style={modalStyles.wrapper}>
          {hasTitleBar && (
            <div className={styles.titleBar}>
              <Header
                icon={icon}
                color={theme.header}
                content={title}
              />
              <div className={styles.close}>
                <Button className={styles.close} circular icon='close' onClick={onHandleClose} />
              </div>
            </div>
          )}
          <div className={styles.content} style={modalStyles.content}>
            {children}
            <Widget {...props} />
          </div>
        </div>
      </Transition>
    </Modal>
  )
}

GenericModal.propTypes = {
  isOpen: PropTypes.bool,
  content: PropTypes.node,
  title: PropTypes.string,
  modalStyles: PropTypes.shape(),
  children: PropTypes.shape(),
  isRounded: PropTypes.bool,
  hasTitleBar: PropTypes.bool,
  onClose: PropTypes.func,
}

GenericModal.defaultProps = {
  isOpen: false,
  content: null,
  title: '',
  modalStyles: {},
  hasTitleBar: false,
  isRounded: true,
  children: null,
  onClose: null
}

export default GenericModal
